import { useMemo } from 'react'

import { DateTime } from 'luxon'

import { faClock } from '@fortawesome/pro-light-svg-icons'

import { sortArrayBy } from '@domain-group/javascript-utils'

import {
  BlankState, Box, DashboardModule, Link,
} from '@domain-group/suit-theme'

import useCustomDeadlines from '@hooks/useCustomDeadlines'
import usePublicationEditionsDeadlines from '@hooks/usePublicationEditionDeadlines'

import DeadlinesImageUrl from './assets/deadlines.svg'
import DeadlineListItem from './DeadlineListItem'

export const icon = faClock

interface DeadlinesProps {
  editing: boolean,
}

const Deadlines = (props: DeadlinesProps) => {
  const {
    editing,
  } = props

  const customDeadlinesPayload = useCustomDeadlines({
    filters: { due_today: true },
    performHttpRequests: true,
    requestOptions: {
      cache_key: DateTime.now().toFormat('yyyy-MM-dd'),
    },
  })
  const { filteredCustomDeadlines, userTimeZone } = customDeadlinesPayload

  const publicationDeadlinesPayload = usePublicationEditionsDeadlines({
    filters: { days_from_now: '0' },
    performHttpRequests: true,
    requestOptions: {
      include_publication_edition_deadlines: true,
      include_publication_edition_publication: true,
      include_unused_editions: true,
      cache_key: DateTime.now().toFormat('yyyy-MM-dd'), // trigger new load each day
    },
  })
  const { filteredPublicationEditionDeadlines, loading } = publicationDeadlinesPayload

  const mappedDeadlines = useMemo(() => {
    const mergedDeadlines = [...filteredCustomDeadlines, ...filteredPublicationEditionDeadlines]

    return sortArrayBy(mergedDeadlines, 'asc', deadline =>
    // @ts-expect-error TS2339
      deadline?.deadline_date || deadline.publication_date)
  }, [filteredCustomDeadlines, filteredPublicationEditionDeadlines])

  const hasDeadlines = !!mappedDeadlines.length

  return (
    <DashboardModule
      editing={editing}
      headerRight={(
        <Link href="#/agency/dashboard/agencies/all/overview/deadlines" textProps={{ fontSize: 'small' }}>
          View All
        </Link>
      )}
      loading={loading}
      title="Deadlines"
    >
      {!loading && !hasDeadlines && (
        <BlankState imageUrl={DeadlinesImageUrl} boxProps={{ borderTop: 'none' }}>
          {/*
           // @ts-expect-error TS2339 */}
          <BlankState.Title>No Relevant Deadlines</BlankState.Title>

          {/*
           // @ts-expect-error TS2339 */}
          <BlankState.Paragraph>
            Create your own custom deadlines or request to have a publication or provider added to view their deadlines.
            {/*
           // @ts-expect-error TS2339 */}
          </BlankState.Paragraph>
        </BlankState>
      )}

      {!loading && hasDeadlines && (
        // @ts-expect-error TS2322
        <DashboardModule.ScrollableSection maxHeight={400}>
          <Box flexDirection="column">
            {mappedDeadlines.map(deadline => (
              <DeadlineListItem
                deadline={deadline}
                // @ts-expect-error TS2339
                key={`${deadline.type}-${deadline.id}`}
                // @ts-expect-error TS2322
                userTimeZone={userTimeZone}
              />
            ))}
          </Box>
        </DashboardModule.ScrollableSection>
      )}
    </DashboardModule>
  )
}

export default Deadlines
